export const AVAILABLE_LOCALIZATIONS = ['de', 'en', 'es', 'fr', 'it', 'pt'];
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_NAVIGATOR_LANGUAGE = 'en-US';
export const DEFAULT_ZENDESK_LANGUAGE = 'en-us';
